/** @jsx jsx */ jsx;
import {jsx} from "@emotion/core";
import axios from "axios";
import React from "react";
import {ChangeInputEvent, IItem, ITaggingRequestProps, ITaggingRequestState} from "./types";

class TaggingRequest extends React.Component<ITaggingRequestProps, ITaggingRequestState> {
    constructor(props: any) {
        super(props);
        this.state = {
            query: "",
            taggingRequestItems: new Array<IItem>()
        };
    }

    onChange = (event: ChangeInputEvent) => {
        const newState = {[event.target.name]: event.target.value};
        this.setState(newState as unknown as ITaggingRequestState);
    }

    shouldSearch = (e) => {
        if (e.key == "Enter") {
            this.onSearch();
        }
    }
    onSearch = async () => {
        // Don't search with an empty field
        if (this.state.query.trim().length == 0) {
            return;
        }

        const resp = await axios.get(this.props.searchUrl + `.json?search=${this.state.query}`);
        this.setState({taggingRequestItems: resp.data.items as IItem[]});
    }

    getRequestUrl = (itemId: number) => {
        return `${this.props.requestUrl}?id=${itemId}`;
    }

    render() {
        return (
            <React.Fragment>
                {/* Search */}
                <div className="center-row">
                    <div className="search-container">
                        <div>
                            <input type="text" id="searchField" name="query" value={this.state.query}
                                   onChange={this.onChange} onKeyPress={this.shouldSearch}/>
                            <button className="man-btn" id="searchBtn" onClick={this.onSearch}>
                                <i className="fa fa-search"/>
                            </button>
                        </div>
                        <div className="legend">Search by Item#, Description</div>
                    </div>
                </div>
                {/* /Search */}

                {/* Search Results */}
                <div className="row search-content-row">
                    <div className="table-responsive col-md-12">
                        <table className="table table-bordered table-striped searchTable">
                            <thead className="thead-inverse">
                            <tr>
                                <th>&nbsp;</th>
                                <th>Item # & Description</th>
                                <th>&nbsp;</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.taggingRequestItems.map((item: IItem, key) =>
                                <tr key={key}>
                                    <td/>
                                    <td>
                                        {`(${item.alu}) ${item.number} ${item.description} `}
                                    </td>
                                    <td>
                                        <a href={this.getRequestUrl(item.id)}
                                           className="man-btn man-green-btn">Choose</a>
                                    </td>
                                </tr>
                            )}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* /Search Results */}
            </React.Fragment>
        );
    }
}

export default TaggingRequest;
